
<side-panel [stepData]="stepData">
    <ng-template let-rowDetail #contentSidePanel>
        <div class="configuration-fields" *ngIf="rowDetail.name=='general'">
            <div class="content">
                <form [formGroup]="form">
                    <div class="more-options">
                        <label class="switch-label"><nz-switch formControlName="showConnection"></nz-switch><span>{{"QUERY_EXCUTOR_SETTINGS.CANCONNECTION"|translateTA}}</span></label>
                        <label class="switch-label"><nz-switch formControlName="canExport"></nz-switch><span>{{"QUERY_EXCUTOR_SETTINGS.CANEXPORTEXCEL"|translateTA}}</span></label>
                        <label class="switch-label"><nz-switch formControlName="canClipboard"></nz-switch><span>{{"QUERY_EXCUTOR_SETTINGS.CANCOPY"|translateTA}}</span></label>
                        <div class="tem-field">
                            <label class="tem-field-label">{{"QUERY_EXCUTOR_SETTINGS.MAXROWS"|translateTA}}</label>
                            <input nz-input type="number" formControlName="maxRows">
                        </div>
                    </div>
                    <nz-divider class="hdivider"></nz-divider>
                </form>
            </div>
        </div>
        <div class="configuration-fields" *ngIf="rowDetail.name=='connection'">
            <ng-container #outlet>
            </ng-container>
            <ng-template #content>
                
                <form-item-component *ngIf="editFace" 
                        [formulario]="formItem" 
                        [formConfiguration]="formItemConfiguration"  
                        [editData]="editData"
                        (saving)="onSavingArray($event)"
                        (canceling)="onCanceling($event)">
                </form-item-component>
            
                <div [hidden]="editFace" class="grid-face">
                    <div class="actions-toolbar">
                        <button nz-button nzType="primary" nzShape="circle" [nz-tooltip]="'add'|translateTA" (click)="add()">
                            <nz-icon nzType="plus"></nz-icon>
                        </button>
                        <span class="space4"></span>
                        <button nz-button nzType="primary" nzDanger nzShape="circle" [nz-tooltip]="'remove'|translateTA" (click)="remove()">
                            <nz-icon nzType="delete"></nz-icon>
                        </button>
                    </div>
                        <div class="fields-grid">
                            <ag-grid-angular
                                style="width: 100%; height: 100%"
                                [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
                                [rowData]="rowsField"
                                [getRowId]="getRowId"
                                [columnDefs]="displayedColumns"
                                (gridReady)="onGridReady($event)"
                                (rowDoubleClicked)="selectRow($event)"
                                (rowClicked)="eventGridSelect($event)"
                                (columnResized)="onResize($event)"
                                (columnMoved)="onReoder($event)"
                                [localeText]="ls.getCurrentGridLocale()"
                                overlayNoRowsTemplate="{{'NODATAFOUND'|translateTA}}"
                                rowBuffer="150"
                                rowSelection="multiple"
                                cacheBlockSize= "100"
                                cacheOverflowSize="2"
                                maxBlocksInCache= 10
                                resizable="true"
                                [pagination]="false"
                                [enableCellTextSelection]="true"
                                [suppressClipboardPaste]="true"
                                [multiSortKey]="true">
                            </ag-grid-angular>
                        </div>
                </div>
            </ng-template>
        </div>
    </ng-template>
</side-panel>


